import { useSelector } from 'react-redux'
import { isInValidValue } from '../../../helpers/value'
import { TYPE_OF_FS } from '../financialStatements/constant'
import {
  selectAuditStatuses,
  selectDataYears,
  selectMethods,
  selectSource,
  selectTypeOfFS,
} from '../financialStatements/store/slice'

const useGetSettingFinancialStatement = () => {
  const auditStatuses = useSelector(selectAuditStatuses)
  const methods = useSelector(selectMethods)
  const sourceId = useSelector(selectSource)?.value
  const typeOfFS = useSelector(selectTypeOfFS)
  const years = useSelector(selectDataYears)

  const checkValue = (valueCheck, value) => {
    return !isInValidValue(valueCheck)
      ? isInValidValue(value)
        ? valueCheck
        : value
      : undefined
  }

  const checkArray = (arr) => {
    return arr?.length ? arr : undefined
  }

  return {
    sourceOrganizationId: checkValue(sourceId),
    isConsolidated: checkValue(
      typeOfFS?.value,
      typeOfFS?.value === TYPE_OF_FS.consolidated.value,
    ),
    auditStatuses: checkArray(auditStatuses),
    methods: checkArray(methods),
    years: checkArray(years),
  }
}

export default useGetSettingFinancialStatement
